const ProfileIndex = () => import('./index')

export default [
  {
    path: '/my-profile',
    name: 'profile.index',
    component: ProfileIndex,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/profile/routes.js